import React, { Component, Suspense } from 'react';
import Header from './components/Header/Header';
import Episodes from './components/Episodes/Episodes';
import Footer from './components/Footer/Footer';
import './css/font-awesome.min.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import EpisodeDetails from './components/Episodes/EpisodeDetails';
import resources from './utils/resources/AppLocalizedStrings';
import NotFound from './components/404/404';

const BlogEntries = React.lazy(() => import('./components/Blog/BlogEntries'));

class App extends Component {

  state = { query: '' };

  onSearch = (e) => this.setState({ query: e.target.value });

  render() {
    return (
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col text-left">
          <Header query={this.state.query} onSearch={this.onSearch} />
          <Routes>
            <Route path="/" element={
              <Episodes title={resources.ourEpisodes} query={this.state.query} />
            } />
            <Route path="/blog" element={
              <Suspense fallback={<div>Loading</div>}>
                <BlogEntries />
              </Suspense>
            } />
            <Route path="/episodes/:id" element={<EpisodeDetails query={this.state.query} />} />
            <Route path="/inicio" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer></Footer>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
